@if (firstFeature) {
  <mat-list role="list">
    @for (property of propArray; track property) {
      <mat-list-item role="listitem">
        <span mat-line><b>{{property.key}}:</b></span>
        <span mat-line> {{property.value}} </span>
      </mat-list-item>
    }
  </mat-list>
}